import { Component, OnInit } from "@angular/core";
import AppConstants from "../../constants/AppConstants";
import { ActivatedRoute } from "@angular/router";
import { DzongkhaService } from "../../services/dzongkha.service";

@Component({
  selector: "app-dzongkha",
  templateUrl: "./dzongkha.component.html",
  styleUrls: ["./dzongkha.component.scss"],
})
export class DzongkhaComponent {
  dzongkhas = [];
  searchQuery = "";
  count: number;
  readonly DEFAULT_PAGE_SIZE = AppConstants.DEFAULT_PAGE_SIZE;
  readonly DEFAULT_PAGE_SIZE_OPTIONS = AppConstants.DEFAULT_PAGE_SIZE_OPTIONS;
  readonly DEFAULT_PAGINATION_INFO = { pageIndex: 0, pageSize: 10 };
  pageIndex = 0;
  pageCursors: any[] = [];
  currentPageSize = 10;
  constructor(
    private route: ActivatedRoute,
    private graphqlService: DzongkhaService,
  ) {
    route.params.subscribe((val) => {
      this.fetchList(this.DEFAULT_PAGINATION_INFO);
    });
  }

  pageChanged({ pageIndex, pageSize }) {
    this.fetchList(
      {
        pageIndex,
        pageSize,
      },
      this.searchQuery,
    );
  }

  search(input) {
    this.pageIndex = 0;
    this.pageCursors = [];
    this.fetchList({ pageIndex: 0, pageSize: this.currentPageSize }, input);
  }

  private fetchList(pageInfo, searchParam?: string) {
    this.pageIndex = pageInfo.pageIndex;
    const cursorForPage = this.pageIndex > 0 ? this.pageCursors[this.pageIndex - 1] : undefined;
    const obj = {
      paginationData: {
        pageIndex: pageInfo.pageIndex,
        pageSize: pageInfo.pageSize,
        after: cursorForPage,
      },
      searchParam: searchParam,
    };
    this.graphqlService.list(obj).subscribe((result) => {
      console.log(result);
      if (result && result.data) {
        this.dzongkhas = result.data["dzongkhas"].edges.map(
          (edge) => edge.node,
        );
        this.count = result.data["dzongkhas"].totalCount;
        this.pageCursors[this.pageIndex] = result.data["dzongkhas"].pageInfo;
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/dzongkha/dzongkha.component.ts